<template>
	<div class="lzHeader">
		<div class="left">
			<div class="icon">
				<i :class="icon"></i>
			</div>
			<div class="title">{{title}}</div>
			<el-link type="info" :underline="false">{{remark}}</el-link>
		</div>
		<div class="right">
			<slot name="right"></slot>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'

	export default {
		computed: {
			...mapGetters(['size'])
		},
		name: 'lzHeader',
		props: {
			title: {
				type: String,
				default: ''
			},
			icon: {
				type: String,
				default: ''
			},
			remark: {
				type: String,
				default: ''
			},
		},
		data() {
			return {}
		},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.lzHeader{
		display: flex;align-items: center;margin: 15px 0 5px;
		.left{
			flex: 1;display: flex;align-items: center;
		}
		.icon{
			width: 30px;height: 30px;line-height: 30px;text-align: center;border: 1px solid #f0f0f0;border-radius: 50%;color: #19A6A0;font-size: 24px;
		}
		.title{
			margin: 0 10px;font-weight: bold;font-size: 14px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/lzHeader/lzHeader.vue